import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { init, miniApp, swipeBehavior, viewport } from '@tma.js/sdk-react'
import { App } from './App'
import './index.css'

/**
 * Инициализация SDK Telegram. Если приложение открыли не из Telegram, SDK
 * бросит исключение — показываем понятное сообщение вместо белого экрана.
 */
async function bootstrap(): Promise<void> {
  const root = createRoot(document.getElementById('root')!)

  try {
    init()

    // ifAvailable сам проверяет, поддерживает ли версия клиента метод, —
    // на старых Telegram приложение просто не будет краситься, а не упадёт.
    miniApp.mount.ifAvailable()
    miniApp.setHeaderColor.ifAvailable('#0f1115')
    miniApp.setBgColor.ifAvailable('#0f1115')

    if (viewport.mount.isAvailable()) {
      await viewport.mount()
      // Отступы под вырез экрана и под шапку самого Telegram уезжают в CSS —
      // раньше нижняя панель была прибита отступом «на глаз» и на телефонах
      // с домашней полоской налезала на неё.
      viewport.bindCssVars.ifAvailable()
    }
    viewport.expand.ifAvailable()

    // Свайп вниз по контенту закрывал приложение прямо посреди прокрутки
    // списка — на экране с длинным дневником это происходит постоянно.
    swipeBehavior.mount.ifAvailable()
    swipeBehavior.disableVertical.ifAvailable()

    // Сообщаем Telegram, что можно убирать плейсхолдер загрузки
    miniApp.ready.ifAvailable()
  } catch (error) {
    console.error('Не удалось инициализировать Telegram SDK', error)
    root.render(
      <div className="flex h-full items-center justify-center p-6 text-center text-ink-2">
        Это приложение открывается из Telegram — через бота @RamisHealth_bot.
      </div>,
    )
    return
  }

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void bootstrap()
